// extracted by mini-css-extract-plugin
export default {"root":"p2rR-HOYoOyKyCvUjRaN1w==","anchor":"Nzl61VbuOSi2WY3xapSrTA==","content":"BhdO3Tuo03KQernYJTd7zA=="};